/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReachabilityWindowResponse } from './ReachabilityWindowResponse';
import {
    ReachabilityWindowResponseFromJSON,
    ReachabilityWindowResponseFromJSONTyped,
    ReachabilityWindowResponseToJSON,
    ReachabilityWindowResponseToJSONTyped,
} from './ReachabilityWindowResponse';

/**
 * 
 * @export
 * @interface PriorityRequestResponse
 */
export interface PriorityRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof PriorityRequestResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof PriorityRequestResponse
     */
    caseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PriorityRequestResponse
     */
    salutation: string | null;
    /**
     * 
     * @type {string}
     * @memberof PriorityRequestResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PriorityRequestResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PriorityRequestResponse
     */
    counselorUserCode: string | null;
    /**
     * 
     * @type {number}
     * @memberof PriorityRequestResponse
     */
    formFillPercent: number;
    /**
     * 
     * @type {Date}
     * @memberof PriorityRequestResponse
     */
    appointmentStartUtc: Date;
    /**
     * 
     * @type {Array<ReachabilityWindowResponse>}
     * @memberof PriorityRequestResponse
     */
    reachabilityWindows: Array<ReachabilityWindowResponse>;
    /**
     * 
     * @type {Date}
     * @memberof PriorityRequestResponse
     */
    lastContactAttemptUtc: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof PriorityRequestResponse
     */
    isReachable: boolean;
}

/**
 * Check if a given object implements the PriorityRequestResponse interface.
 */
export function instanceOfPriorityRequestResponse(value: object): value is PriorityRequestResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('salutation' in value) || value['salutation'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('counselorUserCode' in value) || value['counselorUserCode'] === undefined) return false;
    if (!('formFillPercent' in value) || value['formFillPercent'] === undefined) return false;
    if (!('appointmentStartUtc' in value) || value['appointmentStartUtc'] === undefined) return false;
    if (!('reachabilityWindows' in value) || value['reachabilityWindows'] === undefined) return false;
    if (!('lastContactAttemptUtc' in value) || value['lastContactAttemptUtc'] === undefined) return false;
    if (!('isReachable' in value) || value['isReachable'] === undefined) return false;
    return true;
}

export function PriorityRequestResponseFromJSON(json: any): PriorityRequestResponse {
    return PriorityRequestResponseFromJSONTyped(json, false);
}

export function PriorityRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriorityRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'caseNumber': json['caseNumber'],
        'salutation': json['salutation'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'counselorUserCode': json['counselorUserCode'],
        'formFillPercent': json['formFillPercent'],
        'appointmentStartUtc': (new Date(json['appointmentStartUtc'])),
        'reachabilityWindows': ((json['reachabilityWindows'] as Array<any>).map(ReachabilityWindowResponseFromJSON)),
        'lastContactAttemptUtc': (json['lastContactAttemptUtc'] == null ? null : new Date(json['lastContactAttemptUtc'])),
        'isReachable': json['isReachable'],
    };
}

export function PriorityRequestResponseToJSON(json: any): PriorityRequestResponse {
    return PriorityRequestResponseToJSONTyped(json, false);
}

export function PriorityRequestResponseToJSONTyped(value?: PriorityRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'caseNumber': value['caseNumber'],
        'salutation': value['salutation'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'counselorUserCode': value['counselorUserCode'],
        'formFillPercent': value['formFillPercent'],
        'appointmentStartUtc': value['appointmentStartUtc'].toISOString(),
        'reachabilityWindows': ((value['reachabilityWindows'] as Array<any>).map(ReachabilityWindowResponseToJSON)),
        'lastContactAttemptUtc': value['lastContactAttemptUtc'] == null ? value['lastContactAttemptUtc'] : value['lastContactAttemptUtc'].toISOString(),
        'isReachable': value['isReachable'],
    };
}

